module.exports = __webpack_public_path__ + "img/Ice cream Icon - white.ad54a735.svg";